<template>
  <div class="do-filters-popover text-dark" v-on-clickaway="onClickOutside">
    <button class="do-bttn do-bttn__filter" @click="isShowDropdown = !isShowDropdown">
      <span class="icon-filter"></span>
      {{ title || i18n['filters'] }}
      <div class="do-filters__divider"></div>
      <span class="do-filters__selected-filters" v-if="selectedCount === 0">
        {{ i18n['select_filters'] }}
      </span>
      <span class="do-badge" v-else>
        {{ selectedCount }} {{ i18n['selected'] }}
        <span class="icon-cross2 do-filters-popover__clear"
              :title="i18n['clear_all']"
              @click.stop="$emit('clearAll')"></span>
      </span>
    </button>
    <transition name="d-dropdown">
      <div class="do-filters-popover__dropdown" v-if="isShowDropdown">
        <button v-if="selectedCount > 0"
                @click="$emit('clearAll')"
                class="do-filters__button-transparent">{{ i18n['clear_all'] }}</button>
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
import {mixin as clickaway} from 'vue-clickaway'

const I18N = {
  da: {
    filters: 'Filtre',
    select_filters: 'Vælg filtre',
    selected: 'valgt',
    clear_all: 'Ryd alle'
  },
  en: {
    filters: 'Filters',
    select_filters: 'Select filters',
    selected: 'selected',
    clear_all: 'Clear all'
  },
  nb: {
    filters: 'Filtre',
    select_filters: 'Velg filtre',
    selected: 'valgt',
    clear_all: 'Fjern alle'
  }
}

export default {
  mixins: [clickaway],
  props: {
    title: {
      type: String,
      default: null
    },
    selectedCount: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      isShowDropdown: false
    }
  },
  computed: {
    locale () {
      return this.$store.getters.locale
    },
    i18n () {
      return I18N[this.locale] || I18N['en']
    }
  },
  methods: {
    onClickOutside () {
      this.isShowDropdown = false
    }
  }
}
</script>

<style>
.do-filters-popover {
  position: relative;
}

.do-filters-popover__clear {
  font-size: 0.6rem;
  margin-left: 0.25rem;
  padding: 0.15rem;
  border-radius: 3px;
  color: #6c7a87;
  cursor: pointer;
}

.do-filters-popover__clear:hover {
  background-color: #e4e4e7;
  color: #18181b;
}

.do-filters-popover__dropdown {
  position: absolute;
  z-index: 19990;
  top: calc(100% + 0.5rem);
  left: 0;
  width: 650px;
  max-width: calc(100vw - 2rem);
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, .24);
  text-align: left;
  padding: 0.5rem;
}

.do-filters-popover__item {
  margin-bottom: 1rem;
}

.do-filters-popover__item:last-child {
  margin-bottom: 0;
}

.do-filters-popover__item .d-dropdown-container {
  display: inline-block;
}

.do-filters-popover__quick-filter {
  display: inline-flex;
  align-items: center;
  background: transparent;
  color: #6c7a87;
  border: 1px solid #e4e4e7;
  opacity: 0.8;
  margin: 0 0.5rem 0.5rem 0;
}

.do-filters-popover__quick-filter > span {
  opacity: 0;
  width: 0;
}

.do-filters-popover__quick-filter.do-filters-popover__quick-filter--selected {
  background-color: aliceblue;
  opacity: 1;
  color: var(--primary);
  border-color: var(--primary);
}

.do-filters-popover__quick-filter.do-filters-popover__quick-filter--selected > span {
  opacity: 1;
  width: auto;
  margin-right: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// DoFiltersPopover.vue?2282ab9c